import React, { useEffect, useState, useRef } from 'react';
import { fmesh, fullmesh } from '../../../core/globalVariables.js';
import * as turf from '@turf/turf';
import axios from 'axios';
import CommsToAPI from '../../modals/commsToAPI.js';
import ResetMap from '../../../core/resetMap.js';

const AlterMetrics = ({
  isVisible,
  polygonCustomLayerRef,
  selectedYearEditing,
  dropdownhighlightedIndex,
  setdropdownhighlightedIndex,
  longstandingGeoJSONRef,
  resetLeftSubMenu,
  setisLeftSubDrawerOpen,
  hasChangedKeyValue,
  setHasChangedKeyValue,
  landKeySelectedKey,
  setLandKeySelectedKey,
  globalState,
  globalRefs
}) => {
  const [selectedKey, setSelectedKey] = useState(null);
  const [updatedValue, setUpdatedValue] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const geojson = longstandingGeoJSONRef.current;
  let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
  let setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;
  let currentMapId = globalState.currentMapId;
  let setIsLoadingNewGeoJSONFromAnUpdate = globalState.setIsLoadingNewGeoJSONFromAnUpdate;
  let APIReportMessage = globalState.APIReportMessage;
  let setAPIReportMessage = globalState.setAPIReportMessage;
  let currentMapIdRef = globalRefs.currentMapIdRef;

  let setRecentChangeList = globalState.setRecentChangeList;
  let recentChangeList = globalState.recentChangeList;

  let setIs2DViewActive = globalState.setIs2DViewActive;

  useEffect(() => {
    if (landKeySelectedKey) {
      setSelectedKey(landKeySelectedKey);
    }
  }, [landKeySelectedKey]);
  const handleValueChange = (value) => {
    // const originalFeatures = [];
    setUpdatedValue(value);
    // multuGroupSelectedArray.forEach((selectedSkylarkId) => {
    //   let selectedFeatureForUpdating = longstandingGeoJSONRef.current.features.find(
    //     (f) => f.skylark_id === selectedSkylarkId
    //   );
    //   if (!selectedFeatureForUpdating) return;
    //   const originalFeatureClone = structuredClone(selectedFeatureForUpdating);
    //   originalFeatures.push({ toc: 'Value Change', originalFeature: originalFeatureClone });
    // });
    // setRecentChangeList(prev => {
    //   const newHistory = [...prev, originalFeatures];
    //   return newHistory.slice(-20);
    // });
  };

  useEffect(() => {
    console.log(recentChangeList)
  }, [recentChangeList])

  // const handleConfirm = () => {
  //   if (!selectedKey || updatedValue === '') return;
  //   setHasChangedKeyValue(selectedKey);
  //   polygonCustomLayerRef.current.handleAlteredValue(selectedKey, updatedValue);
  // };

  // - - - - - - - 

  let globalValuesMatrixRef = useRef();

  const generateCalculationMatrix = (geojson, selectedYearEditing, keysWithStrings) => {
    let result = {};
    for (const key of keysWithStrings) {
      result[key] = {
        uniqueValues: new Set(),
        firstFeatures: [],
        numericalValues: []
      };
      for (const feature of geojson.features) {
        if (!feature.feature_data_simple_timeseries) {
          continue;
        }
        if (!(key in feature.feature_data_simple_timeseries)) {
          continue;
        }
        if (!(selectedYearEditing in feature.feature_data_simple_timeseries[key])) {
          continue;
        }
        const value = feature.feature_data_simple_timeseries[key][selectedYearEditing];
        if (typeof value === 'string' && value !== '' && value !== 'undefined' && value !== 'null') {
          result[key].uniqueValues.add(value);
          if (!result[key].firstFeatures.some(f => f.value === value)) {
            let area = null;
            if (feature.geometry) {
              area = turf.area(feature.geometry);
            }
            result[key].firstFeatures.push({ value, feature, area });
            let numericalValuesForFeature = [];
            for (const numericalKey in feature.feature_data_simple_timeseries) {
              if (
                feature.feature_data_simple_timeseries[numericalKey] &&
                selectedYearEditing in feature.feature_data_simple_timeseries[numericalKey]
              ) {
                const numValue = feature.feature_data_simple_timeseries[numericalKey][selectedYearEditing];
                if (typeof numValue === 'number') {
                  numericalValuesForFeature.push({ key: numericalKey, value: numValue });
                }
              }
            }
            result[key].numericalValues.push({
              value,
              numericalValues: numericalValuesForFeature
            });
          }
        } else {
        }
      }
    }
    for (const key in result) {
      result[key].numericalValues = result[key].numericalValues.map(item => {
        return {
          value: item.value,
          results: item.numericalValues.map(numerical => {
            let dividedValue = null;
            const firstFeature = result[key].firstFeatures.find(f => f.value === item.value);
            if (firstFeature && firstFeature.area !== null) {
              dividedValue = numerical.value / firstFeature.area
            }
            return {
              key: numerical.key,
              area: firstFeature.area,
              originalValue: numerical.value,
              dividedValue
            };
          })
        };
      });
    }
    for (const key in result) {
      result[key].uniqueValues = Array.from(result[key].uniqueValues);
    }
    console.log(result)
    globalValuesMatrixRef.current = result;
  };

  const getUniqueStrings = (geojson, selectedYearEditing) => {
    let keysWithStrings = new Set();
    for (const feature of geojson.features) {
      for (const key in feature.feature_data_simple_timeseries) {
        const value = feature.feature_data_simple_timeseries[key][selectedYearEditing];
        if (typeof value === 'string') {
          keysWithStrings.add(key);
        }
      }
    }
    generateCalculationMatrix(geojson, selectedYearEditing, Array.from(keysWithStrings));
  };

  useEffect(() => {
    getUniqueStrings(longstandingGeoJSONRef.current, selectedYearEditing);
  }, [longstandingGeoJSONRef.current, selectedYearEditing])

  const handleConfirm = async () => {
    setIs2DViewActive(false);
    setIsLoadingNewGeoJSONFromAnUpdate(true);
    setAPIReportMessage('Autosaving...')
    if (!selectedKey || updatedValue === '') return;
    setHasChangedKeyValue(selectedKey);
    const updatedGeoJSON = { ...longstandingGeoJSONRef.current };
    const featuresToPatch = [];

    multuGroupSelectedArray.forEach((selectedSkylarkId) => {
      let selectedFeatureForUpdating = longstandingGeoJSONRef.current.features.find(
        (f) => f.skylark_id === selectedSkylarkId
      );

      if (!selectedFeatureForUpdating) return;

      // Clone the feature for updating
      const updatedFeature = { ...selectedFeatureForUpdating };

      const timeSeries = updatedFeature.feature_data_simple_timeseries;

      if (!timeSeries[selectedKey]) return;

      const years = Object.keys(timeSeries[selectedKey]);
      const startYearIndex = years.indexOf(selectedYearEditing);
      if (startYearIndex === -1) return;

      for (let i = startYearIndex; i < years.length; i++) {
        const year = years[i];
        timeSeries[selectedKey][year] = updatedValue;
      }

      if (globalValuesMatrixRef.current.hasOwnProperty(selectedKey)) {
        const featureArea = turf.area(updatedFeature.geometry);

        Object.keys(timeSeries).forEach((key) => {
          if (typeof timeSeries[key][selectedYearEditing] === 'number') {
            const numericalValueEntry = globalValuesMatrixRef.current[selectedKey].numericalValues.find(
              item => item.value === timeSeries[selectedKey][selectedYearEditing]
            );

            if (numericalValueEntry && Array.isArray(numericalValueEntry.results)) {
              const resultEntry = numericalValueEntry.results.find(result => result.key === key);
              if (resultEntry && typeof resultEntry.dividedValue === 'number') {
                const newValue = featureArea * resultEntry.dividedValue;
                for (let i = startYearIndex; i < years.length; i++) {
                  const year = years[i];
                  timeSeries[key][year] = newValue;
                }
              } else {
                console.warn(`No valid 'dividedValue' for key: ${key}`);
              }
            } else {
              console.warn(`No matching numerical value entry for key: ${selectedKey}`);
            }
          }
        });
      } else {
        console.warn(`selectedKey '${selectedKey}' not found in globalValuesMatrix`);
      }

      const featureIndex = updatedGeoJSON.features.findIndex(f => f.skylark_id === updatedFeature.skylark_id);
      if (featureIndex !== -1) {
        updatedGeoJSON.features[featureIndex] = updatedFeature;
      }

      featuresToPatch.push(updatedFeature);
    });

    // ✅ Set recent changes once, with the original (pre-modified) features

    longstandingGeoJSONRef.current = updatedGeoJSON;
    const srid = 4326;
    const cleanedFeatures = featuresToPatch.map(feature => {
      const { type, ...rest } = feature; // remove 'type'

      // Remove 'layer' from feature_data_standard if it exists
      if (rest.feature_data_standard && rest.feature_data_standard.layer) {
        const { layer, ...restStandard } = rest.feature_data_standard;
        rest.feature_data_standard = restStandard;
      }

      return rest;
    });
    // Axios PATCH request using your local API style
    // try {
    //   console.log(cleanedFeatures)
    //   const response = await fetch(`http://localhost:3001/api/maps/${currentMapIdRef.current}/features?srid=${srid}`, {
    //     method: 'PATCH',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(cleanedFeatures),
    //     credentials: 'include',
    //   });

    //   const data = await response.json();
    //   console.log('PATCH success:', data);
    // } catch (err) {
    //   console.error('PATCH error:', err.response?.data || err.message);
    // }

    setRecentChangeList(prev => {
      const newHistory = [
        ...prev,
        featuresToPatch.map(f => ({
          toc: 'Value Change',
          newFeatureChange: structuredClone(f)
        }))
      ];
      return newHistory.slice(-20);
    });

    setTimeout(() => {
      let selectedMetric = globalState.selectedMetric;
      console.log("alter metric:" + " " + selectedMetric)
      // ResetMap(globalRefs, globalState);
      fmesh.children = [];
      fullmesh.remove(fmesh);
      polygonCustomLayerRef.current.createShapes(longstandingGeoJSONRef.current, selectedYearEditing);
      polygonCustomLayerRef.current.getRandomPolygonColor(landKeySelectedKey);
      polygonCustomLayerRef.current.removeFeatureOpacities(fmesh, multuGroupSelectedArray);
      setIsLoadingNewGeoJSONFromAnUpdate(false);
      setAPIReportMessage('')
      polygonCustomLayerRef.current.setCameraTo3DView(true)
      // ResetMap(globalRefs, globalState);
    }, 500);
  };

  // - - - - - - - 

  const handleCancel = () => {
    setSelectedKey(null);
    setUpdatedValue('');
    resetLeftSubMenu();
    setisLeftSubDrawerOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const renderInputField = () => {
    const rawValues = geojson.features
      .map((feature) => feature.feature_data_simple_timeseries[selectedKey]?.[selectedYearEditing])
      .filter((val) => val !== undefined);

    const isNumerical = rawValues.every((val) => {
      if (typeof val === 'number') return true;
      if (typeof val === 'string') {
        const parsed = parseFloat(val);
        return !isNaN(parsed) && val.trim() !== '' && parsed.toString() === val.trim();
      }
      return false;
    });

    const uniqueValues = Array.from(
      new Set(
        rawValues.map((val) => {
          if (typeof val === 'number') return val;
          if (typeof val === 'string') {
            const parsed = parseFloat(val);
            return isNaN(parsed) ? val.trim() : parsed;
          }
          return val;
        })
      )
    ).sort((a, b) => (typeof a === 'number' && typeof b === 'number' ? a - b : 0));

    return (
      <>
        <h3>Update Value:</h3>
        <button
          style={{
            width: '100%',
            marginBottom: '20px',
            marginTop: '10px',
            border: '0px solid #cccccc',
            borderRadius: '5px',
            padding: '11.5px',
            backgroundColor: '#F4F4F7',
          }}
          onClick={toggleDropdown}
        >
          {updatedValue || 'Select a value'}
        </button>
        {isDropdownVisible && (
          <div
            style={{
              width: '100%',
              borderRadius: '5px',
              backgroundColor: '#F4F4F7',
              maxHeight: '200px',
              overflowY: 'auto',
              position: 'relative',
              zIndex: 1,
            }}
          >
            {uniqueValues.map((val, idx) => (
              <div
                key={idx}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                }}
                onClick={() => handleValueChange(val.toString())}
              >
                {val}
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    isVisible && (
      <div style={{ paddingTop: '10px' }}>
        {selectedKey && (
          <div style={{ position: 'relative' }}>
            {renderInputField()}
            <div className="actions">
              <button className="altervaluesbuttons" onClick={handleConfirm}>
                Confirm
              </button>
              <button className="altervaluesbuttons" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default AlterMetrics;
